/**
 * plannerPages — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {A4, tagline, chips, type ToilePack} from './data'

export const plannerPagesPack: ToilePack = {
    slug: 'planner-pages',
    category: 'planner',
    name: 'Planner pages',
    tagline: tagline('pages', 'layouts', 'styles'),
    chips: chips('layouts', 'styles'),
    ratio: A4,
    readings: [
        {key: 'weekly', label: 'Weekly spread', subject: 'seven stacked ruled blocks with a side column for notes'},
        {key: 'habits', label: 'Habit tracker', subject: 'a grid of empty circles with a slim label column'},
        {key: 'meals', label: 'Meal planner', subject: 'day rows by three meal columns, a shopping-list panel'},
    ],
    styles: [
        {key: 'minimal', label: 'Minimal grid', style: 'hairline rules, nothing decorative', palette: 'warm grey on bright white', framing: 'full page, fields left blank'},
        {key: 'botanical', label: 'Botanical', style: 'fine ink leaves and sprigs in the margins', palette: 'ink line on plain white', framing: 'full page, fields left blank'},
        {key: 'pastel', label: 'Pastel blocks', style: 'soft color fields behind each section, no outlines', palette: 'blush, sage and butter', framing: 'full page, fields left blank'},
    ],
    directions: ['a monthly spread instead', 'in muted blue tones', 'with more room to write'],
}
